import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'twoDecimalsFormatPipe',
  pure: true
})
export class TwoDecimalsFormatPipe implements PipeTransform {

  transform(val: number): string {
    if (val !== undefined && val !== null) {
      return val.toFixed(2);
    } else {
      return "";
    }
  }
}